export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || '/api/v1'
export const API_TIMEOUT = 10000 // 10秒超时 